<template>
  <AppDialog :is-open="isDialogOpened"
             :ok-text="$t('common.confirm')"
             @cancel="closeDialog"
             @ok="confirmClick"
  >
    <template #title>{{ $t('project.signing-checklist.add.step2.SigningChecklistAddStep2DeleteStepWarningDialog.title') }}</template>

    <template #body>
      <p>{{ $t("project.signing-checklist.add.step2.SigningChecklistAddStep2DeleteStepWarningDialog.warning") }}</p>
    </template>
  </AppDialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { dialogMixin } from '@/mixins/dialogMixin'

export default defineComponent({
  name: 'SigningChecklistAddStep2DeleteStepWarningDialog',
  components: { AppDialog },
  mixins: [dialogMixin],
  emits: ['confirm'],
  methods: {
    confirmClick () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
})
</script>
